import { lazyEnableNotificationBar } from 'owa-calendar-notification-bar';
import {
    onRequestModuleCommand,
    onResetModuleCommand,
} from '../actions/onRequestModuleCommandActions';
import { orchestrator } from 'satcheljs';

orchestrator(onRequestModuleCommand, actionMessage => {
    const { moduleCommand } = actionMessage;

    lazyEnableNotificationBar.import().then(enableNotificationBar => {
        enableNotificationBar(moduleCommand == null);
    });
});

orchestrator(onResetModuleCommand, () => {
    lazyEnableNotificationBar.import().then(enableNotificationBar => {
        enableNotificationBar(true);
    });
});
